import type { AdminClient, AdminDeposit, AdminTradingAccount } from './types'

/** Visual-review fixtures only — never treat as live ops data. Requires ?fixtures=1 */
export const adminFixtureClients: AdminClient[] = [
  {
    id: 101,
    display_name: 'Asha Verma',
    email: 'a***@example.com',
    email_verified: true,
    status: 'ACTIVE',
    demo_account_count: 1,
    latest_balance: 1020,
    registered_at: '2026-07-20T10:00:00Z',
    last_login_at: '2026-08-06T08:00:00Z',
  },
  {
    id: 102,
    display_name: 'Omar Haddad',
    email: 'o***@example.com',
    email_verified: true,
    status: 'ACTIVE',
    demo_account_count: 1,
    latest_balance: 250,
    registered_at: '2026-07-28T14:20:00Z',
    last_login_at: '2026-08-05T18:00:00Z',
  },
  {
    id: 103,
    display_name: 'Suspended Client',
    email: 's***@example.com',
    email_verified: false,
    status: 'SUSPENDED',
    demo_account_count: 0,
    latest_balance: null,
    registered_at: '2026-06-01T09:00:00Z',
    last_login_at: null,
  },
]

export const adminFixtureAccounts: AdminTradingAccount[] = [
  {
    id: 11,
    mt5_login: 90123456,
    mt5_login_masked: '***56',
    server: 'iBullCapital-Demo',
    mode: 'DEMO',
    currency: 'USD',
    balance: 1020,
    equity: 1014.5,
    status: 'ACTIVE',
    client_id: 101,
    sync_state: 'FIXTURE',
    last_sync_at: '2026-08-06T08:00:00Z',
    created_at: '2026-07-20T10:05:00Z',
  },
]

export const adminFixtureDeposits: AdminDeposit[] = [
  {
    id: 501,
    reference: 'DEP-A1B2-C3',
    amount: '20.00',
    currency: 'USD',
    status: 'PENDING',
    provider: 'MANUAL_DEMO',
    created_at: '2026-08-05T12:00:00Z',
    client_id: 101,
    client_email: 'a***@example.com',
    trading_account_id: 11,
    has_screenshot: true,
    mt5_login_masked: '***56',
  },
  {
    id: 502,
    reference: 'UW-9F81',
    amount: '50.00',
    currency: 'USD',
    status: 'PENDING',
    provider: 'UNIWIRE',
    created_at: '2026-08-05T15:30:00Z',
    client_id: 102,
    trading_account_id: 12,
    has_screenshot: false,
    mt5_login_masked: '***12',
  },
]

export const adminFixtureTimeline = [
  {
    event_type: 'CLIENT_LOGIN',
    timestamp: '2026-08-06T08:00:00Z',
    description: 'Client signed in',
  },
  {
    event_type: 'DEPOSIT_CREATED',
    timestamp: '2026-08-05T12:00:00Z',
    description: 'Manual Demo deposit submitted',
  },
  {
    event_type: 'ACCOUNT_CREATED',
    timestamp: '2026-07-20T10:05:00Z',
    description: 'Demo trading account provisioned',
  },
]

export function useAdminFixturesFromQuery() {
  if (typeof window === 'undefined') return false
  return new URLSearchParams(window.location.search).get('fixtures') === '1'
}
